<div class="primary-key-header">
    <span>{{params.displayName}}</span>
    <span class="info-icon" id="infoPrimaryKeyIcon" [popover]="popoverTemplate" #popoverIconMsg="bs-popover"
        (mouseenter)="popoverIconMsg.show()" (mouseleave)="popoverIconMsg.hide()" container="body" placement="bottom"
        containerClass="info-icon-popover" triggers="manual">
        <svg class="icon-16">
            <use href="../App_Themes/CXone/icons/info.svg#info"></use>
        </svg>
    </span>
</div>
<ng-template #popoverTemplate>
    <div class="popover-wrapper">
        <div class="message">{{primaryKeyInfoMsg}}</div>
    </div>
</ng-template>